import { createContext } from 'react'

export interface IMCsTableContext {
  tagsFilter: Array<string>
  setTagsFilter(statusFilter: Array<string>): void

  refreshMCs(): Promise<void>
}

export const MCsTableContext = createContext<IMCsTableContext>({
  tagsFilter: [],
  setTagsFilter: () => {},

  refreshMCs: async () => {},
})
